import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { imageCodes, titleCodes, textCodes, videoCodes } from '../../template_codes/29/home_page_codes';

export default function Body() {
    return (
        <div>

            {/*                slider image                  */}
            <div class="carousel w-full">
                <div id="slide1" class="carousel-item relative w-full">
                    <img src={imageCodes.homeBanner.image} class="w-full" />
                </div>
            </div>
            {/*                slider image                  */}

            {/*                     category section                    */}
            <div className="container grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 2xl:grid-cols-6 pt-16 px-4">
                <div className="p-2">
                    <img src={imageCodes.category.image} alt="category"></img>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.ringImg.image} alt="Ring"></img>
                        <p className='text-center font-semibold'>{textCodes.rings.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.necklaceImg.image} alt="Necklace"></img>
                        <p className='text-center font-semibold'>{textCodes.necklace.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.braceletImg.image} alt="Bracelet"></img>
                        <p className='text-center font-semibold'>{textCodes.bracelet.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.earringsImg.image} alt="Earrings"></img>
                        <p className='text-center font-semibold'>{textCodes.earrings.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.watchesImg.image} alt="Watches"></img>
                        <p className='text-center font-semibold'>{textCodes.watches.text}</p>
                    </a>
                </div>
            </div>
            {/*                     end of category section                    */}

            {/*                     2 photo section                    */}
            <div className='container py-10 mt-16 w-5/6'>
                <div className="container grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                    <div className='place-content-end ...'>
                        <img src={imageCodes.dragonRing.image} alt="Dragon Ring" className='place-content-end ...'></img>
                    </div>
                    <div>
                        <img src={imageCodes.dragonText.image} alt="Dragon Ring"></img>
                    </div>
                </div>
            </div>
            {/*                     end of 2 photo section                    */}

            {/*                     feature product section                    */}
            <div className='pt-16'>
                <h1 className="text-3xl font-semibold xl:pb-8 pb-4 text-center">{titleCodes.featureProducts.title}</h1>
            </div>
            <div className="container grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 2xl:grid-cols-6 px-4">
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.coupleRings.image} alt="Couple Rings"></img>
                        <p className='text-center font-semibold'>{textCodes.couple.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.animalFigure.image} alt="Animal Figure"></img>
                        <p className='text-center font-semibold'>{textCodes.animal.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.chain.image} alt="Chain"></img>
                        <p className='text-center font-semibold'>{textCodes.chainText.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.pixiu.image} alt="Pixiu"></img>
                        <p className='text-center font-semibold'>{textCodes.pixiuText.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.brandedCollections.image} alt="Branded Collections"></img>
                        <p className='text-center font-semibold'>{textCodes.branded.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.bags.image} alt="Bags"></img>
                        <p className='text-center font-semibold'>{textCodes.bagsText.text}</p>
                    </a>
                </div>
            </div>
            {/*                     end of feature product section                    */}

            {/*                slider image                  */}
            <div class="carousel w-full pt-16">
                <div id="slide1" class="carousel-item relative w-full">
                    <img src={imageCodes.group.image} alt="Group Photo" class="w-full" />
                </div>
            </div>
            {/*                slider image                  */}

            {/*                     series section                    */}
            <div className='pt-16'>
                <h1 className="text-3xl font-semibold xl:pb-8 pb-4 text-center">{titleCodes.series.title}</h1>
            </div>
            <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 px-4">
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.goldSet.image} alt="Gold Set"></img>
                        <p className='text-center font-semibold'>{textCodes.gold.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.diamondSet.image} alt="Diamond Set"></img>
                        <p className='text-center font-semibold'>{textCodes.diamond.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.ptSet.image} alt="PT Set"></img>
                        <p className='text-center font-semibold'>{textCodes.pt.text}</p>
                    </a>
                </div>
                <div className="p-2 hover:-translate-y-1 duration-300 ...">
                    <a href="">
                        <img src={imageCodes.gemstoneSet.image} alt="Gem Stone Set"></img>
                        <p className='text-center font-semibold'>{textCodes.gem.text}</p>
                    </a>
                </div>
            </div>
            {/*                     end of series section                    */}

            {/*               membership section       */}
            <div className='container py-10 mt-16 w-5/6'>
                <div className="container grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                    <div className='place-content-end ...'>
                        <img src={imageCodes.memberPhoto.image} alt="Digital Membership" className='place-content-end ...'></img>
                    </div>
                    <div className='md:px-8 lg:px-8 xl:px-8 2xl:px-8 md:pt-4 lg:pt-4 xl:pt-10 2xl:pt-10'>
                        <p className='tracking-wider leading-loose text-justify'>{textCodes.memberLittleHome.text}</p>
                        <h1 className="text-3xl font-semibold xl:pb-8 pb-4">{titleCodes.memberBigHome.title}</h1>
                        <p className='font-semibold leading-loose text-justify pb-4 '>{textCodes.earnPointsHome.text}</p>
                        <p className='pb-4  leading-loose text-justify'>{textCodes.memberDescHome.text}</p>
                        <Link to={paths.membership}>
                            <button className="btn btn-outline">JOIN NOW</button>
                        </Link>
                    </div>
                </div>
            </div>
            {/*               membership section       */}


            {/*                video section                  */}
            <div class="carousel w-full pt-16">
                <div id="slide1" class="carousel-item relative w-full">
                    <iframe src={videoCodes.video1.video} title="YouTube video player"
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen className="w-full h-96"></iframe>
                </div>
            </div>
            {/*                video section                  */}
        </div>
    )
}
